'use strict';
const options_collection = {
  collectionsLoadMore: '.collections-load-more',
  rangeSlider: '.price-range .range-slider',
  rangeSliderMin: '.range-slider-min',
  rangeSliderMax: '.range-slider-max',
  minPriceRange: '.min-price-range',
  maxPriceRange: '.max-price-range',
  collectionSidebar: '#CollectionSidebar',
  collectionFilterBlocks: '.filter-blocks',
  productgridcontainer: '#productgridcontainer',
  collectionFiltersForm: '#CollectionFiltersForm',
  section: '.sec__collection-main',
};

// When a price sort is active we render the grid ourselves. Hide it up front and
// show a skeleton so customers never see Shopify's native (wrong) order before
// our sorted result paints. A failsafe reveals the grid if our script stalls.
let _psFailsafe = null;

// Effective sort: use the sort in the URL if the customer picked one; otherwise
// fall back to the collection's default sort (set per-collection in Shopify
// admin, exposed via data-default-sort). Only price sorts drive our engine.
function _psDefaultSort() {
  const sec = document.querySelector(options_collection.section);
  return (sec && sec.dataset.defaultSort) || '';
}
function _psEffectiveSort() {
  const sp = new URLSearchParams(window.location.search).get('sort_by');
  const active = sp || _psDefaultSort();
  if (active === 'price-ascending' || active === 'price-descending') {
    return active;
  }
  return null;
}

function _psInjectSkeletonStyles() {
  if (document.getElementById('ps-skel-styles')) return;
  const s = document.createElement('style');
  s.id = 'ps-skel-styles';
  s.textContent =
    '@keyframes ps-shimmer{0%{background-position:-450px 0}100%{background-position:450px 0}}' +
    '.ps-skel-shimmer{background:#ececec;background-image:linear-gradient(90deg,#ececec 0,#f7f7f7 220px,#ececec 440px);background-size:880px 100%;animation:ps-shimmer 1.4s infinite linear}' +
    '.ps-skel-img{width:100%;border-radius:10px}' +
    '.ps-skel-line{height:14px;border-radius:8px;margin:0 auto}' +
    '.ps-skel-title{width:72%;margin-top:16px}' +
    '.ps-skel-price{width:40%;height:16px;margin-top:12px}' +
    '.ps-skel-swatches{display:flex;gap:8px;justify-content:center;margin-top:14px}' +
    '.ps-skel-dot{width:26px;height:26px;border-radius:50%}';
  document.head.appendChild(s);
}

function _psShowSkeleton() {
  const grid = document.getElementById('product-grid');
  if (!grid || document.getElementById('ps-skeleton')) return;
  _psInjectSkeletonStyles();
  const count =
    grid.querySelectorAll('.grid__item:not(.promotion)').length || 12;

  // Mirror the real card's image aspect ratio.
  const ratioEl = grid.querySelector('[style*="--aspect-ratio"]');
  let ratio = ratioEl
    ? ratioEl.style.getPropertyValue('--aspect-ratio').trim()
    : '';
  if (!ratio) ratio = '3/4';

  const skel = document.createElement('div');
  skel.id = 'ps-skeleton';
  // Copy the grid's classes AND inline style so columns and gaps match exactly.
  skel.className = grid.className;
  if (grid.getAttribute('style')) {
    skel.setAttribute('style', grid.getAttribute('style'));
  }

  const dots =
    '<span class="ps-skel-dot ps-skel-shimmer"></span>'.repeat(4);
  let cards = '';
  for (let i = 0; i < count; i++) {
    cards +=
      '<div class="grid__item"><div>' +
      `<div class="ps-skel-img ps-skel-shimmer" style="aspect-ratio:${ratio};"></div>` +
      '<div class="ps-skel-line ps-skel-title ps-skel-shimmer"></div>' +
      '<div class="ps-skel-line ps-skel-price ps-skel-shimmer"></div>' +
      '<div class="ps-skel-swatches">' +
      dots +
      '</div>' +
      '</div></div>';
  }
  skel.innerHTML = cards;
  grid.parentNode.insertBefore(skel, grid.nextSibling);
}

function _psRemoveSkeleton() {
  const skel = document.getElementById('ps-skeleton');
  if (skel) skel.remove();
}

function _psHideGridForSort() {
  if (!_psEffectiveSort()) return;
  const grid = document.getElementById('product-grid');
  if (!grid) return;
  _psShowSkeleton();
  grid.style.display = 'none';
  clearTimeout(_psFailsafe);
  _psFailsafe = setTimeout(_psShowGrid, 8000);
}

function _psShowGrid() {
  clearTimeout(_psFailsafe);
  _psFailsafe = null;
  _psRemoveSkeleton();
  // Drop the server-rendered pre-sort state (it hides the grid with !important).
  document
    .querySelectorAll('.ps-presort')
    .forEach((el) => el.classList.remove('ps-presort'));
  const grid = document.getElementById('product-grid');
  if (grid) grid.style.display = '';
}
_psHideGridForSort();

class BtnFilter extends HTMLElement {
  constructor() {
    super();
    this.collectionSidebar = document.getElementById('CollectionSidebar');
    this.addEventListener('click', this.onOpen.bind(this), false);
  }
  onOpen() {
    if (!this.classList.contains('open')) {
      this.collectionSidebar.classList.add('open');
      document.documentElement.classList.add('open-drawer', 'open-sidebar');
      root.style.setProperty('padding-right', getScrollBarWidth.init() + 'px');
      this.classList.add('open');
    } else {
      this.collectionSidebar.classList.remove('open');
      document.documentElement.classList.remove('open-drawer', 'open-sidebar');
      root.style.removeProperty('padding-right');
      this.classList.remove('open');
    }
  }
}
customElements.define('btn-filter', BtnFilter);
class CloseFilter extends HTMLElement {
  constructor() {
    super();
    this.collectionSidebar = document.getElementById('CollectionSidebar');
    this.addEventListener('click', this.onClose.bind(this), false);
  }
  onClose() {
    this.collectionSidebar.classList.remove('open');
    document.documentElement.classList.remove('open-drawer', 'open-sidebar');
    document.querySelector('.btn-filter').classList.remove('open');
    root.style.removeProperty('padding-right');
  }
}
customElements.define('close-filter', CloseFilter);

class FacetApplyCanvas extends CloseFilter {
  constructor() {
    super();
    this.addEventListener('click', this.onClose.bind(this), false);
  }
}
customElements.define('facet-apply-canvas', FacetApplyCanvas);

class GridMode extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.gridMode.bind(this), false);
  }
  async gridMode() {
    if (this.classList.contains('active')) return;
    const view_mode = this.getAttribute('data-grid-mode');
    if (view_mode == 1) return;
  await motion.animate(
      document.querySelectorAll(
        'motion-element.product-item__wrapper.slide_in'
      ),
      {
        transform: ['translateY(0)', 'translateY(3.5rem)'],
        opacity: [1, 0.01],
        visibility: ['visible', 'hidden'],
      },
      {
        duration: 0.3,
        delay: motion.stagger(0.05),
        easing: [0, 0, 0.3, 1],
      }
    );


    for (var item of document.querySelectorAll('grid-mode')) {
      item.classList.remove('active');
    }
    const container_switch = document.querySelector(
      '.container-products-switch'
    );
    this.classList.add('active');
    const data_view_mode = container_switch.getAttribute('data-view-mode');
    container_switch.classList.remove('grid-columns-' + data_view_mode);
    container_switch.setAttribute('data-view-mode', view_mode);
    container_switch.classList.add('grid-columns-' + view_mode);
    motion.animate(
      document.querySelectorAll(
        'motion-element.product-item__wrapper.slide_in'
      ),
      {
        transform: ['translateY(3.5rem)', 'translateY(0)'],
        opacity: [0.01, 1],
        visibility: ['hidden', 'visible'],
      },
      {
        duration: 0.3,
        delay: motion.stagger(0.1),
        easing: [0, 0, 0.3, 1],
      }
    );
  }
}
customElements.define('grid-mode', GridMode);

class ViewMode extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.viewMode.bind(this), false);
  }
  viewMode() {
    const view_mode = this.getAttribute('data-view');
    if (this.classList.contains('actived')) return;
    var queryString = window.location.search;
    queryString = eventCollectionShopify.removeParam('view', queryString);
    if (view_mode == 'list') {
      var searchParams = queryString.replace('?', '') + '&view=list';
    } else {
      var searchParams = queryString.replace('?', '') + '&view=grid';
    }
    const url = eventCollectionShopify.renderUrl(searchParams);
    eventCollectionShopify.renderSectionFilter(url, searchParams);
  }
}
customElements.define('view-mode', ViewMode);

class FilterItem extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.filterItem.bind(this), false);
  }
  filterItem() {
    if (this.querySelector('.tooltip')) {
      this.querySelector('.tooltip').classList.toggle('current-filter');
    } else {
      if (this.closest('li')) {
        this.closest('li').classList.toggle('current-filter');
      }
    }
    const url = this.getAttribute('data-href');
    eventCollectionShopify.renderSectionFilter(url);
  }
}
customElements.define('filter-item', FilterItem);

class FacetClearAll extends CloseFilter {
  constructor() {
    super();
    this.addEventListener('click', this.filterItem.bind(this), false);
  }
  filterItem() {
    const url = this.getAttribute('data-href');
    eventCollectionShopify.renderSectionFilter(url);
    this.onClose();
  }
}
customElements.define('facet-clear-all', FacetClearAll);

class FilterSort extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.filterSort.bind(this), false);
  }
  filterSort() {
    const value = this.getAttribute('value');
    let queryString = window.location.search;
    queryString = eventCollectionShopify.removeParam('sort_by', queryString);
    const searchParams = queryString.replace('?', '') + '&sort_by=' + value;
    const url = eventCollectionShopify.renderUrl(searchParams);
    eventCollectionShopify.renderSectionFilter(url, searchParams);
  }
}
customElements.define('filter-sort', FilterSort);

class SelectSorter extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.activeFilterSort.bind(this), false);
  }
  activeFilterSort() {
    if (this.closest('.select-custom').classList.contains('active')) {
      this.closest('.select-custom').classList.remove('active');
    } else {
      this.closest('.select-custom').classList.add('active');
    }
  }
}
customElements.define('select-sorter', SelectSorter);

var eventCollectionShopify = (function () {
  return {
    init: function () {
      this.ionRangeSlider();
      this.customPriceSort();
      window.addEventListener('popstate', () => {
        if (this._priceSortMode()) this._renderSortedPage();
      });
      let windowWidth = window.innerWidth;
      if (windowWidth <= 1024) {
        const horizontal = document.querySelector('.horizontal-filter');
        if (horizontal) {
          const collapsible = document.querySelectorAll('collapsible-block');
          collapsible.forEach((e) => {
            e.classList.add('active');
          });
        }
      }
    },

    // Shopify's "Price low/high" sorts by each product's cheapest variant
    // (price_min), but the cards show the FIRST variant's price. When the first
    // variant isn't the cheapest, the shown prices look out of order. This
    // re-orders the visible cards by the price actually printed on each card so
    // the displayed prices match the selected sort. Only affects the current
    // page (Shopify still paginates by its own price_min order).
    reorderByShownPrice: function () {
      const params = new URLSearchParams(window.location.search);
      const sortBy = params.get('sort_by');
      if (sortBy !== 'price-ascending' && sortBy !== 'price-descending') return;

      const grid = document.getElementById('product-grid');
      if (!grid) return;

      const ascending = sortBy === 'price-ascending';
      const items = Array.from(grid.children).filter(
        (el) =>
          el.classList.contains('grid__item') &&
          !el.classList.contains('promotion')
      );
      const promos = Array.from(grid.children).filter(
        (el) =>
          el.classList.contains('grid__item') &&
          el.classList.contains('promotion')
      );
      if (items.length < 2) return;

      const getPrice = (el) => {
        const priceEl = el.querySelector('.card-product-price .price');
        if (!priceEl) return Number.POSITIVE_INFINITY;
        const num = parseFloat(priceEl.textContent.replace(/[^\d.]/g, ''));
        return isNaN(num) ? Number.POSITIVE_INFINITY : num;
      };

      items.sort((a, b) =>
        ascending ? getPrice(a) - getPrice(b) : getPrice(b) - getPrice(a)
      );
      items.forEach((el) => grid.appendChild(el));
      promos.forEach((el) => grid.appendChild(el));
      _psShowGrid();
    },

    // ---- Custom global price sort (handles page-number pagination) ----
    // Shopify paginates by the cheapest variant before any JS runs, so a
    // per-page reorder can't fix a multi-page collection. When a price sort is
    // active we fetch EVERY page once, sort the whole collection by the shown
    // (first-variant) price, then re-paginate the sorted set on the client.

    _priceSortMode: function () {
      return _psEffectiveSort();
    },

    _cardPrice: function (el) {
      const priceEl = el.querySelector('.card-product-price .price');
      if (!priceEl) return Number.POSITIVE_INFINITY;
      const num = parseFloat(priceEl.textContent.replace(/[^\d.]/g, ''));
      return isNaN(num) ? Number.POSITIVE_INFINITY : num;
    },

    // Build the base query (current filters + sort, without page/section_id).
    _baseParams: function () {
      const params = new URLSearchParams(window.location.search);
      params.delete('page');
      params.delete('section_id');
      return params;
    },

    customPriceSort: async function () {
      const sortBy = this._priceSortMode();
      if (!sortBy) return;
      const grid = document.getElementById('product-grid');
      if (!grid) return;
      // Guard against a second cycle running while the first is still fetching
      // (which would re-show the skeleton and look like a double load).
      if (this._psRunning) return;
      this._psRunning = true;
      try {
        await this._runPriceSort(sortBy, grid);
      } finally {
        this._psRunning = false;
      }
    },

    _runPriceSort: async function (sortBy, grid) {

      // Single page (no pagination nav): the simple in-place reorder is enough.
      const hasPagination = !!document.querySelector('.pagination__list');
      if (!hasPagination) {
        this.reorderByShownPrice();
        return;
      }

      const sectionEl = document.querySelector(options_collection.section);
      const sectionId = sectionEl && sectionEl.dataset.sectionId;
      if (!sectionId) {
        this.reorderByShownPrice();
        return;
      }

      const cacheKey = this._baseParams().toString();
      // Reuse fetched-and-sorted cards when only the page changed.
      if (
        !this._psCache ||
        this._psCache.key !== cacheKey ||
        this._psCache.sortBy !== sortBy
      ) {
        try {
          const cards = await this._fetchAllCards(sectionId);
          if (!cards.length) {
            _psShowGrid();
            return;
          }
          const perPage = this._psPerPage || cards.length;
          const ascending = sortBy === 'price-ascending';
          cards.sort((a, b) =>
            ascending
              ? this._cardPrice(a) - this._cardPrice(b)
              : this._cardPrice(b) - this._cardPrice(a)
          );
          this._psCache = { key: cacheKey, sortBy: sortBy, cards, perPage };
        } catch (e) {
          this.reorderByShownPrice();
          return;
        }
      }
      this._renderSortedPage();
    },

    _fetchAllCards: async function (sectionId) {
      const all = [];
      this._psPerPage = null;
      for (let page = 1; page <= 100; page++) {
        const params = this._baseParams();
        params.set('page', page);
        const url = `${window.location.pathname}?section_id=${sectionId}&${params.toString()}`;
        const res = await fetch(url);
        if (!res.ok) break;
        const doc = new DOMParser().parseFromString(
          await res.text(),
          'text/html'
        );
        const pageGrid = doc.getElementById('product-grid');
        if (!pageGrid) break;
        const cards = Array.from(pageGrid.children).filter(
          (el) =>
            el.classList.contains('grid__item') &&
            !el.classList.contains('promotion')
        );
        if (!cards.length) break;
        if (this._psPerPage === null) this._psPerPage = cards.length;
        all.push(...cards);
        if (cards.length < this._psPerPage) break; // last page
      }
      return all;
    },

    _renderSortedPage: function () {
      if (!this._psCache) return;
      const grid = document.getElementById('product-grid');
      if (!grid) return;
      const { cards, perPage } = this._psCache;
      const totalPages = Math.max(1, Math.ceil(cards.length / perPage));
      let current =
        parseInt(new URLSearchParams(window.location.search).get('page'), 10) ||
        1;
      if (current > totalPages) current = totalPages;

      const slice = cards.slice((current - 1) * perPage, current * perPage);
      grid.innerHTML = '';
      slice.forEach((el) => grid.appendChild(el));

      // Cards are <motion-element>s that start hidden (opacity/visibility) and
      // are normally revealed by grid-list's one-time in-view animation. Our
      // injected cards miss that, so force them visible.
      grid.querySelectorAll('motion-element').forEach((m) => {
        m.style.opacity = '1';
        m.style.visibility = 'visible';
        m.style.transform = 'none';
      });

      this._buildPagination(current, totalPages);
      if (typeof initLazyloadItem === 'function') initLazyloadItem();
      if (typeof BlsLazyloadImg !== 'undefined') BlsLazyloadImg.init();
      _psShowGrid();
    },

    _pageList: function (current, total) {
      const delta = 1;
      const range = [];
      const out = [];
      let l;
      for (let i = 1; i <= total; i++) {
        if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
          range.push(i);
        }
      }
      for (const i of range) {
        if (l) {
          if (i - l === 2) out.push(l + 1);
          else if (i - l !== 1) out.push('…');
        }
        out.push(i);
        l = i;
      }
      return out;
    },

    _buildPagination: function (current, total) {
      const list = document.querySelector('.pagination__list');
      if (!list) return;
      const base = this._baseParams();
      const href = (p) => {
        const params = new URLSearchParams(base.toString());
        params.set('page', p);
        return `${window.location.pathname}?${params.toString()}`;
      };
      const numClass =
        'pagination__item rounded-50 lh-1 btn-hover no-underline w-full h-44 border inline-flex align-center justify-content-center remove-underline link';
      let html = '';
      if (current > 1) {
        html += `<li class="w-auto pagination__item--next w-44"><a href="${href(
          current - 1
        )}" data-ps-page="${current - 1}" class="px-15 ${numClass} pagination__item-arrow">‹</a></li>`;
      }
      this._pageList(current, total).forEach((p) => {
        if (p === '…') {
          html += `<li class="w-44"><span class="${numClass.replace(
            'link',
            ''
          )}">…</span></li>`;
        } else if (p === current) {
          html += `<li class="w-44"><a role="link" class="${numClass} pagination__item--current light" aria-current="page">${p}</a></li>`;
        } else {
          html += `<li class="w-44"><a href="${href(
            p
          )}" data-ps-page="${p}" class="${numClass}">${p}</a></li>`;
        }
      });
      if (current < total) {
        html += `<li class="pagination__item--prev"><a href="${href(
          current + 1
        )}" data-ps-page="${current + 1}" class="px-15 ${numClass} pagination__item-arrow">›</a></li>`;
      }
      list.innerHTML = html;

      const _this = this;
      list.querySelectorAll('a[data-ps-page]').forEach((a) => {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          const params = _this._baseParams();
          params.set('page', this.getAttribute('data-ps-page'));
          window.history.pushState(
            {},
            '',
            `${window.location.pathname}?${params.toString()}`
          );
          _this._renderSortedPage();
          const anchor = document.getElementById('productgridcontainer');
          if (anchor) {
            window.scrollTo({
              top:
                anchor.getBoundingClientRect().top + window.pageYOffset - 100,
              behavior: 'smooth',
            });
          }
        });
      });
    },

    ionRangeSlider: function () {
      const price_range = document.querySelector('.price-range');
      const maxRange = document.querySelector(
        options_collection.rangeSliderMax
      );
      const minRange = document.querySelector(
        options_collection.rangeSliderMin
      );
      const minPrice = document.querySelector('.min-price-range');
      const maxPrice = document.querySelector('.max-price-range');
      var minPriceRange = 0;
      var maxPriceRange = 0;
      if (!price_range) return;
      document.querySelector(options_collection.minPriceRange).addEventListener(
        'change',
        (event) => {
          event.preventDefault();
          const target = event.currentTarget;
          target.value = target.value.replace(',', '');
          if (Number(minRange.min) + Number(target.value) >= 0) {
            if (Number(target.value) > Number(maxRange.max)) {
              minPrice.value = Number(maxRange.max);
            } else {
              minPrice.value = Number(target.value);
            }
          } else {
            minPrice.value = Number(minRange.min);
          }
          const formData = new FormData(
            document.querySelector(options_collection.collectionFiltersForm)
          );
          const params = new URLSearchParams(formData).toString();
          const nameMin = minPrice.getAttribute('name');
          const nameMax = maxPrice.getAttribute('name');
          var queryString = window.location.search;
          queryString = this.removeParam(nameMin, queryString);
          queryString = this.removeParam(nameMax, queryString);
          var searchParams = queryString.replace('?', '') + '&' + params;
          const url = this.renderUrl(searchParams);
          this.renderSectionFilter(url, searchParams);
        },
        false
      );
      document.querySelector(options_collection.maxPriceRange).addEventListener(
        'change',
        (event) => {
          event.preventDefault();
          const target = event.currentTarget;
          target.value = target.value.replace(',', '');
          if (Number(maxRange.max) - Number(target.value) >= 0) {
            maxPrice.value = Number(target.value);
          } else {
            maxPrice.value = Number(maxRange.max);
          }
          const formData = new FormData(
            document.querySelector(options_collection.collectionFiltersForm)
          );
          const params = new URLSearchParams(formData).toString();
          const nameMin = minPrice.getAttribute('name');
          const nameMax = maxPrice.getAttribute('name');
          var queryString = window.location.search;
          queryString = this.removeParam(nameMin, queryString);
          queryString = this.removeParam(nameMax, queryString);
          var searchParams = queryString.replace('?', '') + '&' + params;
          const url = this.renderUrl(searchParams);
          this.renderSectionFilter(url, searchParams);
        },
        false
      );
      document
        .querySelector(options_collection.rangeSliderMin)
        .addEventListener(
          'input',
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            if (Number(maxRange.value) - Number(target.value) >= 1) {
              minPrice.value = Number(target.value);
              minPriceRange = Number(target.value) * 100;
            } else {
              target.value = Number(maxRange.value) - 1;
              minPriceRange = (Number(maxRange.value) - 1) * 100;
            }
            const price_format = Shopify.formatMoney(
              minPriceRange,
              cartStrings.money_format
            );
            document.querySelector('.price-lable .min').innerHTML =
              price_format;
            target
              .closest('.price-range')
              .style.setProperty(
                '--range-from',
                (minRange.value / Number(target.getAttribute('max'))) * 100 +
                  '%'
              );
          },
          false
        );
      document
        .querySelector(options_collection.rangeSliderMax)
        .addEventListener(
          'input',
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            if (target.value - minRange.value >= 1) {
              maxPrice.value = target.value;
              maxPriceRange = Number(target.value) * 100;
            } else {
              target.value = Number(minRange.value) + Number(1);
              maxPriceRange = (Number(minRange.value) + Number(1)) * 100;
            }
            const price_format = Shopify.formatMoney(
              maxPriceRange,
              cartStrings.money_format
            );
            document.querySelector('.price-lable .max').innerHTML =
              price_format;
            target
              .closest('.price-range')
              .style.setProperty(
                '--range-to',
                (maxRange.value / Number(target.getAttribute('max'))) * 100 +
                  '%'
              );
          },
          false
        );
      document
        .querySelectorAll(options_collection.rangeSlider)
        .forEach((sliderRange) => {
          sliderRange.addEventListener(
            'change',
            (event) => {
              event.preventDefault();
              const target = event.currentTarget;
              const formData = new FormData(
                document.querySelector(options_collection.collectionFiltersForm)
              );
              const params = new URLSearchParams(formData).toString();
              const nameMin = minPrice.getAttribute('name');
              const nameMax = maxPrice.getAttribute('name');
              var queryString = window.location.search;
              queryString = this.removeParam(nameMin, queryString);
              queryString = this.removeParam(nameMax, queryString);
              var searchParams = queryString.replace('?', '') + '&' + params;
              const url = this.renderUrl(searchParams);
              this.renderSectionFilter(url, searchParams);
            },
            false
          );
        });
    },

    removeParam: function (key, sourceURL) {
      var rtn = sourceURL.split('?')[0],
        param,
        params_arr = [],
        queryString =
          sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : '';
      if (queryString !== '') {
        params_arr = queryString.split('&');
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split('=')[0];
          if (param === key) {
            params_arr.splice(i, 1);
          }
        }
        if (params_arr.length) rtn = rtn + '?' + params_arr.join('&');
      }
      return rtn;
    },

    renderUrl: function (searchParams) {
      const sectionId = document.querySelector(options_collection.section)
        .dataset.sectionId;
      const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
      return url;
    },

    renderSectionFilter: function (url, searchParams) {
      this.toggleLoading(document.body, true);
      const grid_list = document.querySelector('grid-list')
      grid_list.hideGridItems();
      fetch(`${url}`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }
          return response.text();
        })
        .then((responseText) => {
          if (window.innerWidth <= 1024) {
            const collectionFilterBlocks = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector(options_collection.collectionFilterBlocks);
            document.querySelector(
              options_collection.collectionFilterBlocks
            ).innerHTML = collectionFilterBlocks.innerHTML;
            const productgridcontainer = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector(options_collection.productgridcontainer);
            document.querySelector(
              options_collection.productgridcontainer
            ).innerHTML = productgridcontainer.innerHTML;
            if (
              document
                .querySelector(options_collection.collectionSidebar)
                .classList.contains('open')
            ) {
              document.querySelector(options_collection.collectionSidebar).classList.remove('open')
            }
          } else {
            const newSection = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector(options_collection.section);
            document
              .querySelector(options_collection.section)
              .replaceWith(newSection);
          }
          document.documentElement.classList.remove('hside_opened', 'open-drawer', 'open-sidebar');
          const sectionElement = document.querySelector(
            '#productgridcontainer'
          );
          
          if (sectionElement) {
            const elementPosition = sectionElement.getBoundingClientRect().top;
            const offsetPosition = window.pageYOffset;
            const extraOffset = 100;
            const scrollToPosition =
              elementPosition + offsetPosition - extraOffset;
            window.scrollTo({
              top: scrollToPosition,
              behavior: 'smooth',
            });
          }
          this.toggleLoading(document.body, false);
          
        })
        .catch((error) => {
          throw error;
        })
        .finally(() => {
          grid_list?.showGridItems();
          initLazyloadItem();
          BlsLazyloadImg.init();
          eventCollectionShopify.ionRangeSlider();
          // Changing a filter/sort invalidates the cached full-collection sort.
          eventCollectionShopify._psCache = null;
          _psHideGridForSort();
          eventCollectionShopify.customPriceSort();
        });
      this.updateUrl(url, searchParams);
    },

    toggleLoading: function (event, loading) {
      if (event) {
        if (loading) {
          event.classList.add('start', 'loading');
        } else {
          event.classList.add('finish');
          setTimeout(function () {
            event.classList.remove('start', 'loading', 'finish');
          }, 500);
        }
      }
    },

    updateUrl: function (url, searchParams = false) {
      if (searchParams) {
        const urlUpdate = `${window.location.pathname}?${searchParams}`;
        window.history.pushState({ url: urlUpdate }, '', urlUpdate);
      } else {
        window.history.pushState({ url: url }, '', url);
      }
    },
  };
})();
eventCollectionShopify.init();
